// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle/" + chunkId + "." + {"399":"26b1a4f053a61c238217","997":"b34a2b68e6b07153d975"}[chunkId] + ".js";
};